export const routesPath = {
  root: '/',
  payments: '/payments',
  integration: '/integration',
  settings: '/settings',
};
